import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 fade-in">
      <div className="card p-6 max-w-lg w-full">
        {/* Header minimalista */}
        <div className="flex items-start gap-3 mb-4">
          <div className="flex-shrink-0 mt-0.5">
            <AlertCircle className="text-error w-5 h-5" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-50">
              Ha ocurrido un error
            </h3>
            <p className="text-sm text-neutral-600 dark:text-neutral-400 mt-1">
              No se pudo completar la operación
            </p>
          </div>
        </div>

        {/* Mensaje de error */}
        <div className="mb-4">
          <div className="bg-neutral-50 dark:bg-neutral-800 rounded-md p-3 border border-neutral-200 dark:border-neutral-700">
            <p className="text-sm text-neutral-700 dark:text-neutral-300">
              {message}
            </p>
          </div>
        </div>

        {/* Botón de retry minimalista */}
        {onRetry && (
          <div className="flex justify-end">
            <button
              onClick={onRetry}
              className="btn-secondary flex items-center gap-2"
            >
              <RefreshCw size={16} />
              <span>Reintentar</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
